const amountParser: (amount: number) => string = (amount: number) => {
  return `$${amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
};

export default amountParser;
